<template>
  <div class="upsert-reward-affiliate">
    <KTCodePreview v-bind:title="title">
      <template v-slot:preview>
        <div
          v-if="loadingComponent"
          class="d-flex justify-content-center align-items-center"
          style="min-height: 500px"
        >
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <b-row class="pl-0">
            <b-col cols="6">
              <b-row>
                <b-col cols="12">
                  <b-form-group class="required-control">
                    <label>Tên chương trình: </label>
                    <b-form-input
                      size="sm"
                      v-model="mainModel.name"
                      aria-describedby="input-fullName-live-feedback"
                      placeholder="Nhập tên chương trình"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Mô tả:</label>
                    <b-form-textarea
                      v-model="mainModel.description"
                      placeholder="Nhập mô tả chương trình, điều kiện áp dụng"
                      rows="5"
                      :max-length="1000"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <b-row>
                <b-col cols="4">
                  <b-form-group class="required-control">
                    <label>Ngày bắt đầu:</label>
                    <date-picker
                      placeholder="Từ ngày"
                      class="form-control form-control-sm"
                      :config="dpConfigs.date"
                      v-model="mainModel.startAt"
                    ></date-picker>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group class="required-control">
                    <label>Đến ngày</label>
                    <date-picker
                      placeholder="Đến ngày"
                      class="form-control form-control-sm"
                      :config="dpConfigs.date"
                      v-model="mainModel.endAt"
                    ></date-picker>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group>
                    <label>Trạng thái</label>
                    <b-form-select
                      size="sm"
                      class="select-style"
                      v-model="mainModel.status"
                      :options="statusOptions"
                      value-field="value"
                      text-field="name"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Ghi chú:</label>
                    <b-form-textarea
                      v-model="mainModel.note"
                      placeholder="Nhập ghi chú"
                      rows="5"
                      :max-length="1000"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr class="hr-text font-weight-600" data-content="Sản phẩm" />

          <b-row>
            <b-form-group class="col-md-12 pr-0">
              <label>Tìm sản phẩm để thêm vào chương trình:</label>
              <b-col class="row pr-0">
                <b-col md="2" class="p-0">
                  <b-form-select
                    class="select-style border-left-0 rounded-left-0 rounded-right-0"
                    v-model="selectTypeSearchFor"
                    :options="listTypeSearch"
                    size="sm"
                    value-field="id"
                    text-field="name"
                    disabled-field="notEnabled"
                    @change="debounceInputFor"
                  ></b-form-select>
                </b-col>
                <b-col md="2" class="p-0">
                  <b-form-select
                    class="select-style border-left-0 rounded-left-0"
                    v-model="selectTypeOfProductFor"
                    :options="PRODUCT_TYPE_SEARCH"
                    size="sm"
                    value-field="id"
                    text-field="name"
                    disabled-field="notEnabled"
                    disabled
                    @change="debounceInputFor"
                  ></b-form-select>
                </b-col>
                <b-col md="6" class="p-0">
                  <Autosuggest
                    :model="searchProductFor"
                    :suggestions="
                      selectTypeSearchFor === 3
                        ? optionCategories
                        : optionProducts
                    "
                    :placeholder="placeholderTypeSearch"
                    :limit="10"
                    @select="handleSelection"
                    @change="onInputChangeProductFor"
                    :disabled="false"
                    :suggestionName="
                      selectTypeSearchFor === 3 ? 'name' : 'productName'
                    "
                  />
                </b-col>
                <b-col md="2" class="pr-0">
                  <div class="d-flex justify-content-end">
                    <b-button
                      :disabled="isSubmitting('save')"
                      @click="showModalImportProduct"
                      size="sm"
                      variant="secondary"
                      class="font-weight-bolder"
                    >
                      <i style="font-size: 1rem" class="far fa-file-excel"></i
                      >Nhập SP từ excel
                    </b-button>
                  </div>
                </b-col>
              </b-col>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group class="col-md-12 pr-0">
              <label>Tìm sản phẩm trong chương trình:</label>
              <b-col class="row">
                <b-col md="6" class="p-0">
                  <b-form-input
                    v-model.trim="searchProductAddedFor"
                    type="text"
                    placeholder="Tìm kiếm theo tên sản phẩm"
                    size="sm"
                    v-on:keyup.enter="onFilter()"
                  ></b-form-input>
                </b-col>
                <b-col md="1" class="pr-0">
                  <b-button
                    variant="primary"
                    size="sm"
                    class="btn font-weight-bold"
                    @click="onFilter"
                    :disabled="isBusy"
                    @keyup.enter="onFilter"
                  >
                    <i class="fas fa-search text-white fa-lg pl-2"></i>
                    Lọc</b-button
                  >
                </b-col>
                <b-col md="4" class="pr-0"></b-col>
              </b-col>
            </b-form-group>
          </b-row>
          <ImportExcelRewardAffiliate
            ref="reward-affiliate-excel"
            :rewardAffiliateDetails="mainModel.rewardAffiliateDetails"
            v-on:on-receipt-reward-affiliate="onReceiptRewardAffiliate"
          />
          <b-row>
            <b-col md="12">
              <div>
                <b-table
                  bordered
                  hover
                  class="col-md-12"
                  :fields="visibleFields"
                  :items="mainModel.rewardAffiliateDetails"
                  :per-page="perPage"
                  :current-page="currentPageProductTable"
                >
                  <template #cell(count)="row">
                    {{ ++row.index }}
                  </template>
                  <template #cell(inStockQuantity)="row">
                    <span
                      v-b-tooltip.hover
                      title="Tồn thực tế"
                      class="text-primary pr-1"
                      >{{ convertPrice(row.item.totalQuantityInStock) }}</span
                    >
                    <span
                      v-if="row.item.totalQuantityInTransfer"
                      v-b-tooltip.hover
                      title="Tồn đang chuyển kho"
                      class="text-warning pl-1"
                      >+
                      {{ convertPrice(row.item.totalQuantityInTransfer) }}</span
                    >
                  </template>
                  <template #cell(productName)="row">
                    <span
                      v-b-tooltip.hover.right="'Bar code'"
                      class="font-weight-600"
                      >{{ row.item.barCode }}</span
                    ><br />
                    <span v-b-tooltip.hover.right="'Product Id'">{{
                      row.item.productId
                    }}</span
                    ><br />
                    <div class="font-weight-bold">
                      <a
                        href="#"
                        @click.prevent="openProductPage(row.item.productId)"
                        class="text-dark"
                      >
                        <span
                          v-b-tooltip.hover.right="'Tới danh sách sản phẩm con'"
                          class="font-weight-bold"
                          >{{ row.item.productName }}</span
                        >
                      </a>
                    </div>
                  </template>
                  <template #cell(commissionRate)="row">
                    <b-form-input
                      size="sm"
                      v-model="row.item.commissionRate"
                      aria-describedby="input-fullName-live-feedback"
                      placeholder="Nhập tỷ lệ hoa hồng"
                      v-mask="mask"
                      class="text-right"
                      :class="{ 'is-invalid': row.item.commissionRateError }"
                      @input="validateCommissionRate(row.item)"
                      @change="onChangeCommissionRate(row.item)"
                    ></b-form-input>
                    <div
                      v-if="row.item.commissionRateError"
                      class="invalid-feedback"
                    >
                      {{ row.item.commissionRateError }}
                    </div>
                  </template>
                  <template #cell(isError)="row">
                    <div class="d-table-cell align-middle" style="width: 10%">
                      <i
                        v-b-tooltip.hover
                        :title="
                          htmlGetStatusValidate(row.item.isError, 'title')
                        "
                        :class="
                          htmlGetStatusValidate(row.item.isError, 'class')
                        "
                      ></i>
                    </div>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <i
                      class="flaticon2-rubbish-bin-delete-button text-danger"
                      role="button"
                      :style="isSubmitting('save') ? 'pointer-events: none' : null"
                      @click="
                        showDeleteAlert(
                          'Xoá sản phẩm',
                          `Bạn có chắc muốn xoá sản phẩm ${row.item.productName} `,
                          row.item,
                          confirmDeleteProduct,
                        )
                      "
                    ></i>
                  </template>
                </b-table>
                <b-row>
                  <b-col>
                    <p class="mt-3 text-dark font-weight-600">
                      Tổng số:
                      {{ rewardAffiliateDetailsLength }}
                    </p>
                  </b-col>
                  <b-pagination
                    class="custom-pagination"
                    v-show="rewardAffiliateDetailsLength > perPage"
                    v-model="currentPageProductTable"
                    :total-rows="rewardAffiliateDetailsLength"
                    :per-page="perPage"
                    align="right"
                  >
                  </b-pagination>
                </b-row>
              </div>
            </b-col>
            <b-col cols="6" md="4"></b-col>
          </b-row>
        </div>
      </template>
      <template v-slot:foot>
        <SaveButton
          type="button"
          class="font-weight-bolder mr-2 btn-size"
          :button-style="{
            fontWeight: '600',
            whiteSpace: 'nowrap',
          }"
          :is-busy="isSubmitting('save')"
          :disabled="isBusy"
          v-if="
            ['create', 'update'].includes(action) &&
            checkPermissions([
              'REWARD_AFFILIATE_CREATE',
              'REWARD_AFFILIATE_UPDATE',
            ])
          "
          @click="onSubmit"
        >
          {{ actionName }}
        </SaveButton>
        <b-button
          variant="secondary"
          size="sm"
          class="btn-size font-weight-600"
          :disabled="isSubmitting('save')"
          @click="goBack()"
          >Trở về</b-button
        >
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';

import {
  convertPrice,
  removeAccents,
  makeToastFaile,
  makeToastSuccess,
  unMaskPrice,
  currencyMask,
  handleError,
  convertToNumber,
} from '@/utils/common';
import {
  formatDate,
  formatDBDate,
  DP_CONFIG,
  DATE_FORMAT,
  getRemainingDays,
} from '@/utils/date';
import { showDeleteAlert } from '@/utils/sweet-alert2';
import { STATUS_CODE } from '@/utils/enum';
import { cloneDeep, debounce, keyBy } from 'lodash';
import {
  TIME_TRIGGER,
  PRODUCT_TYPE_SEARCH,
  PRODUCT_TYPES,
} from '@/utils/constants';
import ImportExcelRewardAffiliate from '@/view/components/reward-affiliate/ImportExcelRewardAffiliate.vue';
import { checkPermissions } from '@/utils/saveDataToLocal';
import SaveButton from '@/view/components/common/SaveButton.vue';
import submitLock from '@/view/mixins/submit-lock.mixins';

export default {
  data() {
    return {
      PRODUCT_TYPE_SEARCH,
      dpConfigs: DP_CONFIG,
      actionName: 'Lưu',
      action: 'view',
      mask: currencyMask,
      currentPageProductTable: 1,
      perPage: 10,
      categories: [],
      rewardAffiliateDetailFields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '5%',
          },
          tdClass: 'text-center',
          visible: true,
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '30%',
          },
          tdClass: 'text-left',
          visible: true,
        },
        {
          key: 'commissionRate',
          label: 'Tỷ lệ hoa hồng(%)',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '15%',
          },
          tdClass: 'text-right',
          visible: true,
        },
        {
          key: 'isError',
          label: 'Trạng thái',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-center',
          visible: false,
        },
        {
          key: 'errorMessage',
          label: 'Lỗi',
          tdClass: 'text-center',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          visible: false,
        },
        {
          key: 'actions',
          label: 'Hành động',
          tdClass: 'text-center',
          thClass: 'text-center',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          visible: true,
        },
      ],
      selectTypeOfProductFor: 4,
      title: 'Thêm chương trình hoa hồng affiliate',
      filteredProducts: [],
      filteredCategories: [],
      selectTypeSearchFor: 2,
      searchProductFor: '',
      filteredOptionsProduct: [],
      selectTypeSearch: 1,
      mainModel: {
        id: null,
        name: null,
        description: null,
        note: null,
        startAt: null,
        endAt: null,
        rewardAffiliateDetails: [],
      },
      searchProduct: '',
      listTypeSearch: [...PRODUCT_TYPES, { id: 3, name: 'Danh mục' }],
      isBusy: false,
      statusOptions: [
        { value: true, name: 'Hoạt động' },
        { value: false, name: 'Đã ngừng' },
      ],
      loadingComponent: false,
      originalRewardAffiliateDetails: [],
      searchProductAddedFor: '',
    };
  },
  mixins: [submitLock],
  components: {
    SaveButton,
    KTCodePreview,
    Autosuggest,
    ImportExcelRewardAffiliate,
  },
  created() {
    const { id, action, cloneId } = this.$route.query;
    this.action = action;
    if (cloneId) {
      this.mainModel.id = null;
      this.getRewardAffiliateInfo(cloneId);
    } else if (id) {
      this.mainModel.id = id;
      this.getRewardAffiliateInfo(id);
    }
    this.convertActionNameByAction();
    this.convertTitleByAction();
    this.fetchCategories();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.title }]);
  },
  computed: {
    optionProducts() {
      return [...cloneDeep(this.filteredProducts)];
    },
    optionCategories() {
      return [...cloneDeep(this.filteredCategories)];
    },
    rewardAffiliateDetailsLength() {
      return this.mainModel.rewardAffiliateDetails?.length;
    },
    placeholderTypeSearch() {
      return this.isSearchCategory
        ? 'theo tên danh mục để thêm vào chương trình'
        : 'theo tên, mã, mã vạch sản phẩm để thêm vào chương trình';
    },
    visibleFields() {
      return this.rewardAffiliateDetailFields.filter(({ visible }) => visible);
    },
    isSearchCategory() {
      return this.selectTypeSearchFor === 3;
    },
  },

  methods: {
    formatDate,
    convertPrice,
    showDeleteAlert,
    checkPermissions,
    onFilter() {
      const searchNoAccent = removeAccents(
        this.searchProductAddedFor.toLowerCase(),
      );
      this.mainModel.rewardAffiliateDetails =
        this.originalRewardAffiliateDetails.filter(({ productName }) => {
          return removeAccents(productName.toLowerCase()).includes(
            searchNoAccent,
          );
        });
    },
    openProductPage(currentProductId) {
      const routeData = this.$router.resolve({
        name: 'list-products',
        query: {
          childProductId: currentProductId,
          selectedCategory: this.selectedCategory,
        },
      });
      window.open(routeData.href, '_blank');
    },
    onReceiptRewardAffiliate(items) {
      this.mainModel.rewardAffiliateDetails = [
        ...items,
        ...this.mainModel.rewardAffiliateDetails,
      ];
      this.originalRewardAffiliateDetails = [
        ...this.mainModel.rewardAffiliateDetails,
      ];
    },
    showModalImportProduct() {
      this.$refs['reward-affiliate-excel'].showModal();
    },
    convertActionNameByAction() {
      const actionNameMap = {
        create: 'Lưu',
        update: 'Cập nhật',
      };
      this.actionName = actionNameMap[this.action] || 'Lưu';
    },
    convertTitleByAction() {
      const defaultTitle = 'chương trình hoa hồng affiliate';
      const titleMap = {
        create: 'Thêm',
        update: 'Cập nhật',
        view: 'Chi tiết',
      };
      this.title = titleMap[this.action] + ' ' + defaultTitle;
    },
    goBack() {
      this.$router.go(-1);
    },
    async getRewardAffiliateInfo(id = this.mainModel.id) {
      try {
        if (this.isBusy) return;
        this.isBusy = true;
        this.loadingComponent = true;
        const { data } = await ApiService.get(`reward-affiliates/${id}`);
        const rewardAffiliate = data?.data;
        this.mainModel = {
          ...rewardAffiliate,
          id: this.mainModel.id,
          name: this.mainModel.id
            ? rewardAffiliate.name
            : rewardAffiliate.name + ' (Bản sao)',
        };
        this.mainModel.startAt = formatDate(
          rewardAffiliate.startAt,
          DATE_FORMAT,
        );
        this.mainModel.endAt = formatDate(rewardAffiliate.endAt, DATE_FORMAT);
        this.originalRewardAffiliateDetails = [
          ...rewardAffiliate.rewardAffiliateDetails,
        ];
      } catch (error) {
        handleError(error);
      } finally {
        this.isBusy = false;
        this.loadingComponent = false;
      }
    },
    confirmDeleteProduct(deleteItem) {
      this.mainModel.rewardAffiliateDetails =
        this.mainModel.rewardAffiliateDetails.filter(
          ({ productId }) => productId !== deleteItem.productId,
        );
      this.originalRewardAffiliateDetails = [
        ...this.mainModel.rewardAffiliateDetails,
      ];
    },
    createRewardAffiliate(body) {
      return ApiService.post('reward-affiliates', body);
    },
    updateRewardAffiliate(body) {
      return ApiService.put(`reward-affiliates/${this.mainModel.id}`, body);
    },
    dispatchRewardAffiliateRequest(action, body) {
      switch (action) {
        case 'create':
          return this.createRewardAffiliate(body);
        case 'update':
          return this.updateRewardAffiliate(body);
        default:
          throw new Error(`Action: '${action}' không hợp lệ!`);
      }
    },
    onSubmit() {
      return this.withSubmitLock('save', () => this.doSubmit());
    },
    async doSubmit() {
      if (!this.validateData()) return;
      const body = {
        ...this.mainModel,
        startAt: formatDBDate(this.mainModel.startAt),
        endAt: formatDBDate(this.mainModel.endAt),
        rewardAffiliateDetails: this.mapRewardAffiliateDetailsModel(
          this.mainModel.rewardAffiliateDetails,
        ),
      };
      try {
        const result = await this.dispatchRewardAffiliateRequest(
          this.action,
          body,
        );
        if (result.data?.status === STATUS_CODE.SUCCESS) {
          makeToastSuccess(result.data.message);
          this.goBack();
        }
      } catch (error) {
        handleError(error);
        this.handleErrorProduct(error);
      }
    },
    handleErrorProduct(error) {
      const validProductResults = error.response?.data?.data;
      if (!validProductResults || !validProductResults.length) return;
      this.showValidationFields();

      const validProductResultsMap = keyBy(validProductResults, 'productId');
      this.mainModel.rewardAffiliateDetails.forEach((detail) => {
        const validProductResult = validProductResultsMap[detail.productId];
        if (validProductResult) {
          detail.isError = true;
          detail.errorMessage = validProductResult.errorMessage;
        }
      });
    },
    mapRewardAffiliateDetailsModel(rewardAffiliateDetails) {
      return rewardAffiliateDetails.map((rewardAffiliateDetail) => {
        return {
          id: rewardAffiliateDetail.id,
          productId: rewardAffiliateDetail.productId,
          commissionRate: convertToNumber({
            value: rewardAffiliateDetail.commissionRate,
          }),
        };
      });
    },
    debounceInputFor: debounce(function () {
      if (!this.isSearching) {
        let textSearch = this.searchProductFor;
        if (this.isSearchCategory) {
          this.fetchCategory(textSearch);
        } else {
          this.fetchProduct(textSearch);
        }
      }
    }, TIME_TRIGGER),
    onInputChangeProductFor(text) {
      this.searchProductFor = text;
      this.debounceInputFor();
    },
    async fetchCategory(textSearch) {
      this.filterCategory(textSearch);
    },
    async fetchProduct(textSearch) {
      try {
        this.filteredProducts = this.filterProduct(textSearch);
        const searchProduct = textSearch ? textSearch.trim() : null;
        if (!this.filteredProducts?.length) {
          this.isSearching = true;
          const params = {
            searchProduct: searchProduct,
            typeSearch: this.selectTypeSearchFor,
            typeOfProduct: this.selectTypeOfProductFor,
          };
          this.filteredProducts = await this.searchProductByType(params);
        }
      } catch (error) {
        handleError(error);
      } finally {
        this.isSearching = false;
      }
    },
    filterProduct(searchText) {
      return this.filteredProducts.filter((item) => {
        return (
          item.productName.toLowerCase().indexOf(searchText.toLowerCase()) >
            -1 ||
          removeAccents(item.productName).indexOf(removeAccents(searchText)) >
            -1
        );
      });
    },
    filterCategory(searchText) {
      const filteredCategories = this.categories.filter((item) => {
        return (
          item.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1 ||
          removeAccents(item.name).indexOf(removeAccents(searchText)) > -1
        );
      });
      this.filteredCategories = [...filteredCategories];
    },
    validateData() {
      if (!this.mainModel.name?.trim()) {
        makeToastFaile('Nhập tên affiliate');
        return false;
      }
      if (!this.mainModel.startAt) {
        makeToastFaile('Chọn ngày bắt đầu');
        return false;
      }
      if (!this.mainModel.endAt) {
        makeToastFaile('Chọn ngày kết thúc');
        return false;
      }

      const remainingDays = getRemainingDays(
        this.mainModel.startAt,
        this.mainModel.endAt,
        DATE_FORMAT,
      );
      if (remainingDays < 1) {
        makeToastFaile(
          'Ngày kết thúc phải lớn hơn ngày bắt đầu ít nhất 1 ngày!',
        );
        return false;
      }
      // Validate commission rate for each product
      for (const detail of this.mainModel.rewardAffiliateDetails) {
        const validationResult = this.validateCommissionRateValue(
          detail.commissionRate,
        );
        if (!validationResult.isValid) {
          makeToastFaile(validationResult.error);
          return false;
        }
      }
      return true;
    },
    async searchProductByType(params) {
      const {
        data: { data },
      } = await ApiService.query(`productSearch/search-by-type`, {
        params,
      });
      return data;
    },
    async handleSelection(option) {
      if (!option || !option.item) return;
      this.searchProductFor = '';
      if (this.isSearchCategory) {
        const listProducts = await this.fetchProductsByCategory(option.item.id);
        const newProducts = listProducts.reduce((acc, product) => {
          const isDuplicate = this.isDuplicateProduct(product.id);
          if (isDuplicate) {
            makeToastFaile(`${product.name} đã tồn tại`);
          } else {
            acc.push({
              productId: product.productId ?? product.id,
              productName: product.name,
              productCode: product.code,
              commissionRate: '',
            });
          }
          return acc;
        }, []);

        this.mainModel.rewardAffiliateDetails = [
          ...newProducts,
          ...this.mainModel.rewardAffiliateDetails,
        ];
      } else {
        if (this.isDuplicateProduct(option.item.productId)) {
          return makeToastFaile(`${option.item.productName} đã tồn tại`);
        }
        this.mainModel.rewardAffiliateDetails.unshift({
          productId: option.item.productId,
          productName: option.item.productName,
          productCode: option.item.productCode,
          barCode: option.item.barCode,
          commissionRate: '',
        });
      }
      this.originalRewardAffiliateDetails = [
        ...this.mainModel.rewardAffiliateDetails,
      ];
    },
    isDuplicateProduct(productId) {
      return this.mainModel.rewardAffiliateDetails.some(
        (existingProduct) => existingProduct.productId === productId,
      );
    },
    showValidationFields() {
      this.rewardAffiliateDetailFields = this.rewardAffiliateDetailFields.map(
        (field) => {
          if (field.key === 'isError' || field.key === 'errorMessage') {
            return { ...field, visible: true };
          }
          return field;
        },
      );
    },
    async fetchCategories() {
      try {
        const {
          data: { data },
        } = await ApiService.get('category');
        this.categories = data.list_caterogy;
        this.filteredCategories = [...this.categories];
      } catch (error) {
        handleError(error);
      }
    },
    async fetchProductsByCategory(categoryId) {
      try {
        const params = {
          categoryIds: [categoryId],
          searchProduct: this.searchProductFor,
          typeOfProduct: this.selectTypeOfProductFor,
        };
        const {
          data: { data },
        } = await ApiService.query(`productSearch/search-by-product-category`, {
          params,
        });
        return data;
      } catch (error) {
        handleError(error);
      }
    },
    htmlGetStatusValidate(isError, type) {
      let name = '';
      switch (isError) {
        case false: {
          name =
            type === 'class'
              ? 'fa fa-check-circle text-primary'
              : 'Sẵn sàng tạo mới';
          break;
        }
        default: {
          name =
            type === 'class'
              ? 'fas fa-times-circle text-danger'
              : 'Không hợp lệ';
        }
      }
      return name;
    },
    onChangeCommissionRate(item) {
      // Cập nhật lại original reward affiliate details
      const index = this.originalRewardAffiliateDetails.findIndex(
        ({ productId }) => productId === item.productId,
      );
      if (index !== -1) {
        this.originalRewardAffiliateDetails[index] = item;
      }
    },
    validateCommissionRate(item) {
      if (!item.commissionRate) return item.commissionRate;
      const validationResult = this.validateCommissionRateValue(
        item.commissionRate,
      );
      if (validationResult.isValid) {
        item.commissionRate = validationResult.value;
        item.commissionRateError = null;
      } else {
        item.commissionRate = validationResult.value;
        item.commissionRateError = validationResult.error;
      }
    },
    validateCommissionRateValue(value) {
      const rate = unMaskPrice(value);
      if (rate === null || rate === undefined || rate === '') {
        return {
          isValid: false,
          value: '0',
          error: 'Vui lòng nhập tỷ lệ hoa hồng',
        };
      }

      const numRate = parseFloat(rate);
      if (numRate < 0) {
        return {
          isValid: false,
          value: '0',
          error: 'Tỷ lệ hoa hồng không được nhỏ hơn 0',
        };
      }
      if (numRate > 100) {
        return {
          isValid: false,
          value: '100',
          error: 'Tỷ lệ hoa hồng không được lớn hơn 100',
        };
      }

      const decimalPlaces = (rate.toString().split('.')[1] || '').length;
      if (decimalPlaces > 2) {
        const truncatedRate = Math.floor(numRate * 100) / 100;
        return {
          isValid: false,
          value: truncatedRate.toString(),
          error: 'Tỷ lệ hoa hồng chỉ được phép có tối đa 2 chữ số thập phân',
        };
      }

      return {
        isValid: true,
        value: value,
        error: null,
      };
    },
  },
};
</script>
<style scoped>
.font-weight-600 {
  font-weight: 600;
}

.btn-size {
  width: 90px;
}
</style>
